<template>
  <slot
    v-bind="{ preselectTransportChoiceId, preselectTransportChoice, iframeUrl, storeAndClose }"
  ></slot>
</template>

<script>
import fillPickupPoint from './helpers/fillPickupPoint'

const BASE_IFRAME_URL =
  'https://www.google.com/maps/embed/v1/place?key=AIzaSyBtMxq6RyjqchnSvcCP2q71PekBcjIIA8A&q='
const DEFAULT_ADDRESS = 'Rybná 14, Praha 1'

export default {
  emits: ['on-choice-select'],
  props: {
    transportId: {
      type: Number,
      required: true
    },
    transportTypeChoiceIdFromOrder: {
      type: Number
    }
  },
  data() {
    return {
      preselectTransportChoiceId: null,
      iframeUrl: null
    }
  },
  computed: {
    getSelectedTransportChoice() {
      return this.$controls['frm-form-transport_type_choices_' + this.transportId].items.filter(
        item => item.id == this.preselectTransportChoiceId
      )[0]
    }
  },
  methods: {
    setIframeUrl(newAddress) {
      this.iframeUrl = BASE_IFRAME_URL + newAddress
    },
    preselectTransportChoice(transportChoiceId) {
      this.preselectTransportChoiceId = transportChoiceId

      this.$nextTick(() => {
        this.setIframeUrl(
          this.getSelectedTransportChoice.street
          + ', '
          + this.getSelectedTransportChoice.city
        )
      })
    },
    storeAndClose() {
      this.selectTransportChoice(this.preselectTransportChoiceId, this.transportId)
    },
    selectTransportChoice(transportChoiceId, transportTypeId) {
      this.$formValues['frm-form-transport_type_choices_' + transportTypeId + ':change'] =
        transportChoiceId

      this.$nextTick(() => {
        fillPickupPoint(null)
        document.querySelector('#frm-form-transport_type_id-' + transportTypeId).click()
      })

      this.$emit('on-choice-select')
    }
  },
  mounted() {
    if (this.transportTypeChoiceIdFromOrder) {
      this.preselectTransportChoice(this.transportTypeChoiceIdFromOrder)
    } else {
      this.setIframeUrl(DEFAULT_ADDRESS)
    }
  }
}
</script>

<style lang="scss" scoped></style>
